document.addEventListener("DOMContentLoaded", function() {
  // Sticky header: Ag Bull .main-nav and Wiesemeyer .wiesemeyers-landing-header (see _navigation.css .sticky).
  var stickyHeaders = document.querySelectorAll(".main-nav, .wiesemeyers-landing-header");
  if (stickyHeaders.length) {
    window.addEventListener("scroll", function() {
      var stuck = window.scrollY > 1;
      stickyHeaders.forEach(function(header) {
        header.classList.toggle("sticky", stuck);
      });
    });
  }

  // Initialize HC Off-canvas Nav
  if (typeof jQuery !== 'undefined' && jQuery('#main-nav').length) {
    jQuery(function($) {
      $('#main-nav').hcOffcanvasNav({
        disableAt: 1300,
        customToggle: $('.toggle-button'),
        navTitle: 'Menu',
        insertClose: false,
        navTitle: '',  
        navClass: 'g39-offcanvas-nav',
        levelTitles: false,
        levelTitleAsBack: false,
        labelBack: '',
      });
    });
  }

  jQuery('.scroll-to-anchor a[href^="#"]').on('click', function(event) {
    event.preventDefault();
    var target = this.hash;
    var $target = jQuery(target);
    jQuery('html, body').animate({
      scrollTop: $target.offset().top-170
    }, 800);
  });

});